import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/Home'
import Xilografia from '../components/Xilografia'
import Oxigrafia from '../components/Oxigrafia'
import Lithografia from '../components/Lithografia'
import Gallery from '../components/Gallery'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  base: '/xaraktiki/',
  routes: [
    {
      path: '/',
      name: 'εργαστήριο χαρακτικής',
      component: Home
    },
    {
      path: '/xilografia',
      name: 'ξυλογραφία',
      component: Xilografia,
      title: 'ξυλογραφία'
    },
    {
      path: '/oxigrafia',
      name: 'οξυγραφία',
      component: Oxigrafia,
      title: 'οξυγραφία'
    },
    {
      path: '/lithografia',
      name: 'λιθογραφία',
      component: Lithografia,
      title: 'λιθογραφία'
    },
    {
      path: '/gallery',
      name: 'γκαλερί',
      component: Gallery,
      title: 'γκαλερί'
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js